import { render, staticRenderFns } from "./traanchitro.vue?vue&type=template&id=270fea0c&scoped=true&"
import script from "./traanchitro.vue?vue&type=script&lang=js&"
export * from "./traanchitro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270fea0c",
  null
  
)

export default component.exports